import axios, { AxiosResponse, AxiosError } from 'axios'
import { MContactMessage } from '@Models/client/contact.model'
import { ICommonQuery } from '@Models/common.model'
import * as Redux from 'redux'
import { APIServices } from '@Services/api.service'
import { ClientActionTypes } from '@ClientStores/client.action-types'
import SharedActions from '@SharedActions/loading.action'
import { ToastServices } from '@Services/toast.service'

const CONTACTS = '/contacts'

const addContact = (body: any) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        return new Promise((resolve, reject) => {
            axios
                .post(CONTACTS, body)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Contact created')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const getMessages = (params?: ICommonQuery) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        axios
            .get(`${CONTACTS}/FAQs`, { params })
            .then((response: AxiosResponse) => {
                const { data, metadata } = response?.data
                const messages = data?.map(
                    (item: MContactMessage) => new MContactMessage(item)
                )
                const payload = {
                    messages,
                    messagesMetadata: metadata,
                }
                dispatch({ type: ClientActionTypes.GET_MESSAGES, payload })
                dispatch(SharedActions.setClientLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const ClientContactActions = {
    addContact,
    getMessages,
}

export default ClientContactActions
